import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap'
import { AppDispatch, RootState } from 'store';

import instagramPlatformLogo from "../../assets/images/platforms/platform-instagram.png"
import youtubePlatformLogo from "../../assets/images/platforms/platform-youtube.png"
import { toast } from 'react-toastify';
import { getErrorMessage } from 'utils/helpers';
import { addSocialAccount } from 'services/api/social-account';
import { fetchSocialAccountsThunk } from 'slices/auth/thunk';
import { useNavigate } from 'react-router-dom';
const platforms = [
    {
        id: 'ig',
        name: 'Instagram',
    },
    {
        id: 'yt',
        name: 'Youtube'
    }
]


const platformLogos = {
    ig: instagramPlatformLogo,
    yt: youtubePlatformLogo
};

const AddSocialAccount: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {
    const [processing, setProcessing] = useState(false);

    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const [errors, setErrors] = useState<{ platform?: string, handle?: string }>({});
    const socialAccounts = useSelector((state: RootState) => state.auth.social_accounts.items);
    const maxIGAccountsLimit = useSelector((state: RootState) => state.auth.configurations?.agency_max_ig_accounts);
    const maxYTAccountsLimit = useSelector((state: RootState) => state.auth.configurations?.agency_max_yt_accounts);
    const [maxSocialAccountsConfig, setMaxSocialAccountsConfig] = useState<Record<string, number>>({
        ig: Number(maxIGAccountsLimit),
        yt: Number(maxYTAccountsLimit)
    })
    const navigate = useNavigate();

    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);

    useEffect(() => {
        setMaxSocialAccountsConfig({
            ig: Number(maxIGAccountsLimit),
            yt: Number(maxYTAccountsLimit)
        })
    }, [maxIGAccountsLimit, maxYTAccountsLimit])


    const availablePlatforms = platforms.filter(platform => {
        const maxForPlatform = maxSocialAccountsConfig[platform.id] || 1;
        const currentCountForPlatform = socialAccounts.filter((account) => account.social_account.platform === platform.id).length;

        return currentCountForPlatform < maxForPlatform;
    });

    const [data, setData] = useState<{ platform: string, handle: string }>({ platform: availablePlatforms.length === 0 ? '' : (availablePlatforms.length === 1 ? availablePlatforms[0].id : 'ig'), handle: '' });

    const validateForm = () => {
        let newErrors: { platform?: string, handle?: string } = {};
        if (!data.platform) {
            newErrors.platform = "Please select a social media platform.";
        }
        if (!data.handle) {
            newErrors.handle = "Please enter your social media handle or profile link.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateForm() || !selectedAgencyId) return;
        try {
            setProcessing(true);
            const res = await addSocialAccount(selectedAgencyId, data)
            toast.success("Social account added successfully.");
            onClose();
            dispatch(fetchSocialAccountsThunk({force: true}));
        } catch (error: any) {
            console.error(error);
            toast.error(getErrorMessage(error) || "Failed to add social account. Please try again.");
        } finally {
            setProcessing(false);
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className='application-cost-approval-modal' >
            <div className="modal-body">
                <h6 className='application-cost-approval-modal-title mb-3'>Add Social Account</h6>
                <div className="mt-4 d-flex flex-column gap-3">
                    <div className="form-group">
                        <div className="d-flex flex-column">
                            <label htmlFor="campaignGoal">Platform <span className="text-danger">*</span></label>
                        </div>
                        <div className="logo-radio-tile-group">
                            {
                                Object.values(availablePlatforms).map((platform) => (
                                    <div key={platform.id} className={`logo-radio-tile cursor-pointer ${platform.id === data.platform ? 'active' : ''}`} onClick={() => {
                                        setData({ ...data, platform: platform.id })
                                    }}>
                                        <img className='h-100' src={platformLogos[platform.id as keyof typeof platformLogos]} />
                                    </div>
                                ))
                            }
                        </div>
                        {errors.platform && <div className="text-danger font-12 mt-1">{errors.platform}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="platform">Handle/Profile Link</label>
                        <input value={data.handle}
                            onBlur={validateForm}
                            onChange={(e) => {
                                setData({ ...data, handle: e.target.value });
                            }} type="text" className="form-control profile-input-form-control" id="handle" name="handle" placeholder="Enter your social media handle or profile link" />
                        {errors.handle && <div className="text-danger font-12 mt-1">{errors.handle}</div>}
                    </div>
                </div>

                {/* Save Changes Button */}
                <div className="mt-4 d-flex justify-content-between align-items-center gap-4">
                    <button className="btn btn-gradient-outline w-50" onClick={onClose}>Cancel</button>
                    <button onClick={handleSubmit} className="btn btn-gradient w-50" disabled={processing || (!data.platform || !data.handle)}>{processing ? 'Adding...' : 'Add'}</button>
                </div>
            </div>
        </Modal >
    )
}

export default AddSocialAccount
